import React, { useState, useEffect } from "react";
import Moment from "moment";

// Redux
import PropTypes from "prop-types";
import genericAction from "@Actions/generic";
import { getChatsHistoric } from "@Actions/chats";

// Components
import Text from "@Components/Text";
import { Button, Checkbox, Dropdown, Form, Label, Icon, Grid } from "semantic-ui-react";
import Input from "@Components/Input";
import { dropdownFormat } from "@Utils/formats";
import IKModal from "@Components/IkModal";
import InputFilter from "@Components/InputFilter";

// Lodash
import { isEmpty, map, filter, find, get } from "lodash";
// Modals
// import InputContactFilter from "@Components/InputContactFilter";
import TextareaAutosize from "react-textarea-autosize";

// staticData
import { contactOption, dropdownOptions } from "./staticData";

// Styles
import styles from "./styles.module.css";

const HistoryChatFilter = ({
	onClose,
	channels,
	dispatch,
	channelfilters,
	setChannelfilters,
	groupsfilters,
	setGroupsfilters,
	tagsSelected,
	setTagsSelected,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	contacts,
	setContacts,
	agents,
	setAgents,
	note,
	setNote,
	onApplyFilters,
	dateField,
	setDateField,
	tabValue,
	setTabValue,
	stateValue,
	setStateValue,
	orderBy,
	setOrderBy,
	orderDirection,
	setOrderDirection,
}) => {
	const [channelfiltersData, setChannelfiltersData] = useState([]);
	const [channelAll, setChannelAll] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);
	const [groupsData, setGroupsData] = useState([]);
	const [agentsData, setAgentsData] = useState("");
	const [tagsData, setTagsData] = useState("");
	const [cleaned, setCleaned] = useState(false);
	const [errors, setErrors] = useState({ channelfilters: "", selected: "" });
	const [tempOrderBy, setTempOrderBy] = useState(orderBy || "");
	const [tempOrderDirection, setTempOrderDirection] = useState(orderDirection || "");

	useEffect(() => {
		if (dateField === "closeDate") {
			setTempOrderBy("closeDate");
			setTempOrderDirection("desc");
		}
		if (dateField === "createdDate") {
			setTempOrderBy("createdDate");
			setTempOrderDirection("desc");
		}
	}, [dateField]);

	useEffect(() => {
		(async () => {
			const usersPromise = dispatch(genericAction({ method: "get", route: "users/all" }));
			const tagsPromise = dispatch(genericAction({ method: "get", route: "tags/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const [usersResponse, tagsResponse, groupResponse] = await Promise.all([usersPromise, tagsPromise, groupPromise]);
			const platoformsMapped = map(channels, (item) => {
				return {
					key: item.id,
					text: `${item.platform?.name} - ${item.label}`,
					value: item.id,
				};
			});
			const groupsMapped = dropdownFormat(groupResponse, "name", "id");
			const agentsMapped = dropdownFormat(usersResponse, "user.fullName", "userId");
			const tagsMapped = dropdownFormat(tagsResponse, "name", "id");

			setChannelfiltersData(platoformsMapped);
			setGroupsData(groupsMapped);
			setAgentsData(agentsMapped);
			setTagsData(tagsMapped);
		})();
	}, []);

	const checkAll = (name) => {
		switch (name) {
			case "channelfilters":
				if (!channelAll) {
					const channelAllArray = map(channels, (item) => {
						return item.id;
					});
					setChannelfilters(channelAllArray);
					setChannelAll(!channelAll);
				} else {
					setChannelfilters([]);
					setChannelAll(!channelAll);
				}
				break;
			case "groupsfilters":
				if (!groupsAll) {
					const groupArray = map(groupsData, (item) => {
						return item.value;
					});
					setGroupsfilters(groupArray);
					setGroupsAll(!groupsAll);
				} else {
					setGroupsfilters([]);
					setGroupsAll(!groupsAll);
				}
				break;
			default:
				break;
		}
	};

	const handleInput = (e) => {
		const { name, value } = e.target;
		if (name === "startDate") {
			setStartDate(value);
		} else {
			setEndDate(value);
		}
	};

	const handleTipyfication = (name, data) => {
		setTagsSelected(data);
	};

	const onFilter = async () => {
		const contactId = contacts && contacts.id ? contacts.id : null;

		let errorsTest = {};

		if (isEmpty(tempOrderBy)) {
			errorsTest = {
				...errorsTest,
				orderBy: "El campo 'Ordenar por' es requerido para poder filtrar",
			};
		}
		if (isEmpty(tempOrderDirection)) {
			errorsTest = {
				...errorsTest,
				orderDirection: "a",
			};
		}
		if (!isEmpty(errorsTest)) {
			setErrors(errorsTest);
			return null;
		}

		if (
			isEmpty(agents) &&
			!contactId &&
			isEmpty(groupsfilters) &&
			isEmpty(tagsSelected) &&
			isEmpty(startDate) &&
			isEmpty(endDate) &&
			isEmpty(note) &&
			isEmpty(channelfilters) &&
			isEmpty(stateValue) &&
			isEmpty(tempOrderBy) &&
			isEmpty(tempOrderDirection) &&
			isEmpty(tabValue)
		) {
			errorsTest = {
				...errorsTest,
				selected: "Debe seleccionar mínimo un campo",
			};
			setErrors(errorsTest);
			return null;
		}
		setErrors({});
		setOrderBy(tempOrderBy);
		setOrderDirection(tempOrderDirection);

		const filters = {
			agents,
			contact: contactId,
			channels: channelfilters,
			groups: groupsfilters,
			tags: tagsSelected,
			closeState: stateValue,
			startDate,
			endDate,
			dateField,
			text: note,
			orderKey: tempOrderBy,
			orderDir: tempOrderDirection,
		};

		if (tabValue) {
			filters.closeTab = tabValue;
		} else {
			filters.closeTab = null;
		}

		await dispatch(getChatsHistoric(filters));
		if (isEmpty(errorsTest.channelfilters) && isEmpty(errorsTest.selected)) {
			if (onApplyFilters) {
				onApplyFilters();
			} else {
				onClose();
			}
		}
	};

	const onChangeDropdown = (value, name) => {
		if (name === "channelfilters") {
			setChannelfilters(value);
			if (channelfiltersData.length === value.length) {
				setChannelAll(true);
			} else {
				setChannelAll(false);
			}
		} else if (name === "groupsfilters") {
			setGroupsfilters(value);
			if (groupsData.length === value.length) {
				setGroupsAll(true);
			} else {
				setGroupsAll(false);
			}
		}
	};

	const onContactsSelect = (item) => {
		setContacts(item);
	};

	const onContactsRemove = () => {
		setContacts({});
	};

	const renderLabelChannels = (label) => {
		return {
			color: "blue",
			content: `${label.text}`,
			icon: label.icon,
		};
	};

	const renderLabelDepartments = (label) => {
		return {
			color: "blue",
			content: `${label.text} `,
			icon: "building outline",
		};
	};
	const cleanModal = () => {
		setAgents([]);
		setContacts("");
		setChannelfilters([]);
		setGroupsfilters([]);
		setTagsSelected([]);
		setStartDate("");
		setStateValue("");
		setEndDate("");
		setNote("");
		setGroupsAll(false);
		setChannelAll(false);
		setErrors({ channelfilters: "", selected: "" });
		setCleaned(true);
		setTabValue("");
		setTimeout(() => {
			setCleaned(false);
		}, 2000);
	};
	const handleInputDropdown = (event, { value }) => {
		setTagsSelected(value);
	};

	const handleCloseModal = () => {
		onClose();
	};

	const getDropdownOption = (key) => {
		const option = find(dropdownOptions, { key });
		return option ? option.options : [];
	};

	const getDateFieldOptions = () => {
		return getDropdownOption("dateField");
	};
	const getOrderDirectionOptions = () => {
		return getDropdownOption("orderDirection");
	};
	const getTabsOptions = () => {
		return getDropdownOption("closeTab");
	};
	const getStateValueOptions = () => {
		return getDropdownOption("stateValue");
	};

	const getOrderByOptions = () => {
		const options = getDropdownOption("orderBy");
		let filteredOptions = filter(options, (option) => {
			if (dateField === "closeDate" && option.value === "createdDate") return false;
			if (dateField === "createdDate" && option.value === "closeDate") return false;
			return true;
		});
		if (tabValue === "client" || tabValue === "atender") {
			filteredOptions = filter(filteredOptions, (option) => {
				return option.value !== "newChat";
			});
		}
		return filteredOptions;
	};

	const handleOrderByChange = (value) => {
		setTempOrderBy(value);
		if (value === "createdDate" || value === "closeDate") {
			setDateField(value);
		}
	};

	const getFieldsetClass = (filters, data) => {
		if (isEmpty(filters) && isEmpty(agents) && isEmpty(tagsSelected)) return "";

		const ratio = filters.length / data.length;

		if (ratio > 0.75 || !isEmpty(agents) || !isEmpty(tagsSelected)) return styles.hasMostOptions;
		if (ratio > 0.5) return styles.hasManyOptions;

		return styles.hasOptions;
	};

	const renderContactInfo = (rowData) => {
		const channel = get(rowData, "contact.channel", "");
		const isEmail = channel && channel.toLowerCase() === "email";
		const value = isEmail ? get(rowData, "email", "") : get(rowData, "phone", "");
		const label = isEmail ? "Correo" : "Tel";
		return {
			label,
			value,
			shouldTruncate: isEmail,
		};
	};

	return (
		<IKModal
			iconName="chat"
			title="Histórico de chat"
			onClose={handleCloseModal}
			onSuccess={onFilter}
			cancelLabel="Cancelar"
			saveLabel="Filtrar"
			fullHeight
			size="small">
			<Grid className={styles.grid}>
				{(!isEmpty(errors.selected) || !isEmpty(errors.orderBy)) && (
					<div className={styles.center}>
						<Label className={styles.labelError} basic color="red">
							{errors.selected || errors.orderBy}
						</Label>
					</div>
				)}
				<div className={styles.containerFirst}>
					<fieldset className={styles.fieldset}>
						<legend className={styles.legendWithButton}>
							<span className={styles.legend}>Filtrado</span>
							<div className={styles.clearButtonContainer}>
								<Button icon size="mini" onClick={cleanModal} className={styles.clearButtonInline}>
									<Icon name="trash alternate outline" />
									Limpiar Todo
								</Button>
								{cleaned && <span className={styles.tooltipAbove}>¡Filtros limpiados!</span>}
							</div>
						</legend>

						<div className={styles.dateContent}>
							<div className={styles.dateFieldDate}>
								<div className={styles.flexContainer}>
									<Input
										type="date"
										label="Desde:"
										icon="calendar minus"
										iconPosition="left"
										placeholder="Inicio"
										fluid
										size="mini"
										name="startDate"
										value={startDate}
										max={Moment().format("YYYY-MM-DD")}
										onChange={handleInput}
										className={styles.dateInput}
									/>
									<Input
										type="date"
										label="Hasta:"
										icon="calendar plus"
										iconPosition="left"
										placeholder="Final"
										fluid
										size="mini"
										name="endDate"
										value={endDate}
										min={startDate}
										max={Moment().format("YYYY-MM-DD")}
										onChange={handleInput}
										className={styles.dateInput}
									/>
								</div>

								<div className={styles.containerOptions}>
									<div className={styles.containerOrder}>
										<Text className={styles.textTypificacion}>Opciones:</Text>
										<Dropdown
											fluid
											search
											value={dateField}
											options={getDateFieldOptions()}
											onChange={(e, { value }) => {
												return setDateField(value);
											}}
											className={styles.dropdownfont}
										/>
									</div>
									<div className={styles.containerOrder} />
								</div>

								<div className={styles.containerOptionsSpecial}>
									<div className={styles.containerOrder}>
										<Text className={styles.textTypificacion}>Ordenar por:</Text>
										<Dropdown
											fluid
											search
											placeholder="Seleccionar"
											options={getOrderByOptions()}
											value={tempOrderBy}
											onChange={(e, { value }) => {
												return handleOrderByChange(value);
											}}
											selection
											clearable
											error={!!errors.orderBy && !tempOrderBy}
										/>
									</div>
									<div className={styles.containerOrder}>
										<Text className={styles.textTypificacionSpecial}>&nbsp;</Text>
										<Dropdown
											fluid
											search
											placeholder="Seleccionar"
											options={getOrderDirectionOptions()}
											value={tempOrderDirection}
											onChange={(e, { value }) => {
												setTempOrderDirection(value);
											}}
											selection
											clearable
											error={!!errors.orderDirection && tempOrderBy && !tempOrderDirection}
										/>
									</div>
								</div>
								<div className={styles.containerOptions}>
									<div className={styles.containerOrder}>
										<Text className={styles.textTypificacion}>Tabs:</Text>
										<Dropdown
											fluid
											search
											placeholder="Seleccionar"
											options={getTabsOptions()}
											value={tabValue}
											onChange={(e, { value }) => {
												return setTabValue(value);
											}}
											selection
											clearable
										/>
									</div>
									<div className={styles.containerOrder}>
										<Text className={styles.textTypificacion}>Estado:</Text>
										<Dropdown
											fluid
											search
											placeholder="Seleccionar"
											options={getStateValueOptions()}
											value={stateValue}
											onChange={(e, { value }) => {
												return setStateValue(value);
											}}
											selection
											clearable
										/>
									</div>
								</div>
							</div>
						</div>
					</fieldset>

					<fieldset className={styles.fieldsetOtros}>
						<legend className={styles.legend}>Otros</legend>
						<div className={styles.contactContainer}>
							<div className={styles.lookUpLabel}>Contacto:</div>
							<InputFilter
								contactData={contacts}
								selectedContact={onContactsSelect}
								onEmpty={onContactsRemove}
								selectTitle="Seleccionar Contacto"
								url="contacts"
								defaultField="all"
								forceInputValue="name"
								tableColumns={contactOption}
								mobileCardView
								cardLine1={[
									{ label: "ID", key: "id" },
									{ label: "", key: "name" },
									{ label: "Plat", key: "contact.channel" },
								]}
								cardLine2={[
									{
										key: "email",
										label: "",
										format: "truncate",
										stringLength: 30,
										render: renderContactInfo,
									},
								]}
							/>
						</div>
						<div className={styles.userContainerTags}>
							<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
								<Text className={styles.lookUpLabel}>Usuarios:</Text>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return setAgents(value);
									}}
									value={agents}
									renderLabel={renderLabelChannels}
									multiple
									selection
									search
									clearable
									options={agentsData}
								/>
							</div>
							<div className={`${styles.userDropdownBlock} ${styles.typification}`}>
								<Text className={styles.lookUpLabel}>Etiquetas:</Text>
								<Dropdown
									fluid
									name="tagsSelected"
									value={tagsSelected}
									onChange={handleInputDropdown}
									options={tagsData}
									handleSelection={handleTipyfication}
									size="mini"
									search
									multiple
									selection
									clearable
									selected
									renderLabel={renderLabelChannels}
								/>
							</div>
						</div>
						<Form className={styles.typification}>
							<Text className={styles.textTypificacion}>Texto:</Text>
							<div style={{ position: "relative" }}>
								<TextareaAutosize
									value={note}
									name="messageArea"
									onChange={(e) => {
										return setNote(e.target.value);
									}}
									className={styles.inputGroupB}
									rows={1}
								/>
								{note && (
									<Icon
										name="x"
										className={styles.iconCloseInside}
										onClick={() => {
											setNote("");
										}}
									/>
								)}
							</div>
						</Form>
					</fieldset>
				</div>

				<div className={styles.filtersContainer}>
					<fieldset
						className={`${styles.fieldsetChannel} ${!isEmpty(errors.selected) ? styles.error : ""} ${getFieldsetClass(
							channelfilters,
							channelfiltersData
						)}`}>
						<legend className={styles.legend}>Canales</legend>
						<div className={styles.section}>
							<div className={styles.contDiv}>
								<Checkbox
									className={styles.checkBox}
									name="channelAll"
									checked={channelAll}
									onChange={() => {
										return checkAll("channelfilters");
									}}
								/>
								{!isEmpty(errors.channelfilters) && (
									<Text className={styles.ErrorChannel} color="red">
										{errors.channelfilters}
									</Text>
								)}
								<Text className={styles.sectionTitleText}>Todos</Text>
							</div>

							<div className={styles.sectionContent}>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return onChangeDropdown(value, "channelfilters");
									}}
									value={channelfilters}
									placeholder="Seleccionar"
									multiple
									clearable
									search
									selection
									options={channelfiltersData}
									renderLabel={renderLabelChannels}
									upward
								/>
							</div>
						</div>
					</fieldset>

					{!isEmpty(groupsData) && (
						<fieldset
							className={`${styles.fieldsetGroup} ${!isEmpty(errors.selected) ? styles.error : ""} ${getFieldsetClass(
								groupsfilters,
								groupsData
							)}`}>
							<legend className={styles.legend}>Grupos</legend>
							<div className={styles.contDiv}>
								<Checkbox
									name="groupsAll"
									className={styles.checkBox}
									checked={groupsAll}
									onChange={() => {
										return checkAll("groupsfilters");
									}}
								/>
								<Text className={styles.sectionTitleText}>Todos</Text>
							</div>

							<div className={styles.sectionContent}>
								<Dropdown
									fluid
									onChange={(e, { value }) => {
										return onChangeDropdown(value, "groupsfilters");
									}}
									placeholder="Seleccionar"
									multiple
									clearable
									search
									selection
									value={groupsfilters}
									options={groupsData}
									renderLabel={renderLabelDepartments}
									upward
								/>
							</div>
						</fieldset>
					)}
				</div>
			</Grid>
		</IKModal>
	);
};

HistoryChatFilter.propTypes = {
	onClose: PropTypes.func,
	channels: PropTypes.object,
	dispatch: PropTypes.func,
	channelfilters: PropTypes.array,
	setChannelfilters: PropTypes.func,
	groupsfilters: PropTypes.array,
	setGroupsfilters: PropTypes.func,
	tagsSelected: PropTypes.array,
	setTagsSelected: PropTypes.func,
	startDate: PropTypes.string,
	setStartDate: PropTypes.func,
	endDate: PropTypes.string,
	setEndDate: PropTypes.func,
	contacts: PropTypes.object,
	setContacts: PropTypes.func,
	agents: PropTypes.array,
	setAgents: PropTypes.func,
	note: PropTypes.string,
	setNote: PropTypes.func,
	dateField: PropTypes.string,
	setDateField: PropTypes.func,
	onApplyFilters: PropTypes.func,
	stateValue: PropTypes.string,
	setStateValue: PropTypes.func,
	orderBy: PropTypes.string,
	setOrderBy: PropTypes.func,
	orderDirection: PropTypes.string,
	setOrderDirection: PropTypes.func,
	tabValue: PropTypes.string,
	setTabValue: PropTypes.func,
};

export default HistoryChatFilter;
